import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FormationAzureFundamentals.css';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionFormationAF from '../../components/FormationsAzureFundamentals/IntroSectionFormationAF/IntroSectionFormationAF';
import IntroSectionFormationAF2 from '../../components/FormationsAzureFundamentals/IntroSectionFormationAF/IntroSectionFormationAF2';
import IntroSectionFormationAF3 from '../../components/FormationsAzureFundamentals/IntroSectionFormationAF/IntroSectionFormationAF3';
import ServicesCardsPrivateCloud from '../../components/PrivateCloud/ServicesCardsPrivateCloud/ServicesCardsPrivateCloud';
import PricingSectionAzureAf from '../../components/ui/pricing-section-azure-af';
import Navbar from "../../components/Common/Navbar/Navbar";
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ParallaxComponent from '../../components/Common/ParallaxBackground/ParallaxComponent';
import ParallaxIMG0 from './../../assets/images/nas-synology-1.png';
import ParallaxIMG2 from './../../assets/images/nas-synology-3.png';
import ParallaxIMG1 from './../../assets/images/nas-synology-3.png';
import ExpertiseSection from '../../components/PrivateCloud/ExpertiseSectionPrivateCloud/ExpertiseSectionPrivateCloud';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData12 from '../../components/Common/IntroSectionBottom/introSectionData12';
import useSectionRefs from '../../hooks/useSectionRefs';
import ContactComponent from '../../components/Common/ContactComponent/ContactComponent';
import TimelineFormationEntra from '../../components/FormationsEntra/TimelineFormationEntra/TimelineFormationEntra';
import BenefitsPrivateCloud from '../../components/PrivateCloud/ServicesSliderPrivateCloud/BenefitsPrivateCloud';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import { contactLinkData } from '../../data/contactLinkData';
import CertificationsSection from '../../components/FormationsEntra/CertificationsSection/CertificationsSection';
import TimelineFormationCF from '../../components/FormationsAzureFundamentals/TimelineFormationCF/TimelineFormationCF';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import { FeaturesSectionWithHoverEffects } from '../../components/ui/feature-section-with-hoover-effect';
import  formationAFFeatures from './../../data/features/formationAF';

const FormationsAzure: React.FC = () => {
    const sectionRefs = useSectionRefs();  
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const { t } = useTranslation();
  
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
  
    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

  return (
    <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header 
            title={t('navbar.academy.azureFundamentals.title', 'Azure Cloud Fundamentals')} 
            subtitle={t('navbar.academy.azureFundamentals.subtitle', 'Formation pour maîtriser l\'écosystème Azure')} 
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionFormationAF />
      </section>
      <section id="commitment" className="section light commitment-section">
        <IntroSectionFormationAF3 />
      </section>
      <section id="cloud" className="section dark">
        <IntroSectionFormationAF2 />
      </section>
      <section id="pricing" className="section dark">
        <PricingSectionAzureAf openContactModal={handleOpenContactModal} />
      </section>
      <div className="gradient-bg">
      <section id="start2" className="section dark" ref={sectionRefs.start2}>
          <div className="gradient-bg">
          <TimelineFormationCF />
          <GridPatternCard>
      <GridPatternCardBody>
        <div className="tw-h-[5em]">
        </div>
      </GridPatternCardBody>
    </GridPatternCard>
          </div>
        </section>
      </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="azureFundamentals" />
        <Footer />
      </section>
      <ContactComponent 
        isOpen={isContactModalOpen}
        onClose={handleCloseContactModal}
      />
    </div>
  );
};

export default FormationsAzure;
